import React, { useRef, useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import {
  IoArrowBackCircleOutline,
  IoArrowForwardCircleOutline,
} from "react-icons/io5";

import { projects } from "../data/data";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import "../styles/Portfolio.css";

function Portfolio() {
  const prevRef = useRef(null);
  const nextRef = useRef(null);
  const swiperRef = useRef(null);
  const [preview, setPreview] = useState(3);
  const [size, setSize] = useState(32);

  useEffect(() => {
    if (swiperRef.current) {
      swiperRef.current.params.navigation.prevEl = prevRef.current;
      swiperRef.current.params.navigation.nextEl = nextRef.current;

      swiperRef.current.navigation.destroy();
      swiperRef.current.navigation.init();
      swiperRef.current.navigation.update();
    }
  }, []);

  useEffect(() => {
    if (window.innerWidth < 768) {
      setPreview(1);
      setSize(18);
    }
  }, [window.innerWidth]);

  return (
    <div className="portfolio" id="portfolio">
      <h1>Portfolio</h1>

      <div className="carousel-container">
        <button ref={prevRef} className="custom-button prev-button">
          <IoArrowBackCircleOutline size={size} color={"#f9b452"} />
        </button>

        <Swiper
          ref={swiperRef}
          slidesPerView={preview}
          spaceBetween={24}
          loop={true}
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
          }}
          navigation={{
            prevEl: prevRef.current,
            nextEl: nextRef.current,
          }}
          onBeforeInit={(swiper) => {
            swiperRef.current = swiper;
          }}
          modules={[Navigation]}
        >
          {projects.map((el, i) => (
            <SwiperSlide key={i}>
              <div className="card">
                <div className="foto">
                  <img src={el.photo} alt="project" />
                </div>

                <div className="text">
                  <h3>{el.title}</h3>
                  <p>{el.description}</p>
                </div>

                <div className="btn">
                  {el.github_url !== null && (
                    <a href={el.github_url} target="_blank" rel="noreferrer">
                      <button>Github</button>
                    </a>
                  )}

                  {el.deploy_url !== null && (
                    <a href={el.deploy_url} target="_blank" rel="noreferrer">
                      <button>Demo</button>
                    </a>
                  )}
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>

        <button ref={nextRef} className="custom-button next-button">
          <IoArrowForwardCircleOutline size={size} color={"#f9b452"} />
        </button>
      </div>
    </div>
  );
}

export default Portfolio;
